// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/style.scss
// module id = 1
// module chunks = 0